import type React from 'react'

import LearnerFeedbackQ from '@/queries/LearnerFeedbackQ'
import UserQ from '@/queries/UserQ'
import type { Query } from '@/client/query'
import getPositionInSeries from '@/client/services/session/getPositionInSeries'

import LearnerFeedbackCard from '@/components/LearnerFeedback/LearnerFeedbackCard'
import { userDetailsFromQuery } from '@/components/Worlds/transforms/detailsFromQueries'
import { USER_FIELDS_FOR_AVATAR } from '@/components/Worlds/UI/Avatar/AvatarWithName'

// The dialogues reflection modal's query-side mapping onto LearnerFeedbackCard, kept
// next to its only tape caller. Delete when the dialogues surfaces move to typed
// payloads; the series feedback page maps its payload directly.
export default function LearnerFeedbackDisplayFromQuery({
  feedback,
  showRecipient = false,
  showType = false,
}: {
  feedback: Query
  showRecipient?: boolean
  showType?: boolean
}): React.ReactElement {
  const reviewer = feedback.one(UserQ.where({ id: LearnerFeedbackQ.reviewer_user_id }))
  const reviewee = feedback.one(UserQ.where({ id: LearnerFeedbackQ.reviewee_user_id }))

  const reviewerUser = userDetailsFromQuery(USER_FIELDS_FOR_AVATAR, { user: reviewer })
  const revieweeUser = userDetailsFromQuery(USER_FIELDS_FOR_AVATAR, { user: reviewee })

  const isSelfReflection = revieweeUser.id === reviewerUser.id
  const createdAt = feedback(LearnerFeedbackQ.created_at) ?? new Date().toISOString()
  const comment = feedback(LearnerFeedbackQ.comment)
  const tags = feedback(LearnerFeedbackQ.attribute_tags) ?? []

  return (
    <LearnerFeedbackCard
      user={showRecipient ? revieweeUser : reviewerUser}
      isSelfReflection={isSelfReflection}
      showRecipient={showRecipient}
      showType={showType}
      positionInSeries={getPositionInSeries(feedback)}
      createdAt={createdAt}
      comment={comment}
      tags={tags}
    />
  )
}
